export default ({
  typeColumn,
  icon,
}) => ({
  componentName: 'cell-number-and-tooltips',
  componentArgs: {
    typeColumn,
    icon,
  },
});
